'use client'

import { Button } from '@algoacademy/design-system/web/actions/Button'
import { usePathname } from 'next/navigation'

export function LoginButton() {
  const pathname = usePathname()
  const href = `/auth/login?redirectTo=${encodeURIComponent(pathname)}`

  return (
    <Button href={href} className='hidden md:block'>
      Zaloguj się
    </Button>
  )
}
